<template><div><h1 id="anonymisierung-profile" tabindex="-1"><a class="header-anchor" href="#anonymisierung-profile"><span>Anonymisierung Profile</span></a></h1>
<p>Anonymisierung Profile — Einstellungen für die Anonymisierung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Der Einsatz von Profilen ermöglicht organisations- und prozessspezifische Definitionen zum anonymisieren und löschen von Daten. Im Profil sind die zu bearbeitenden Daten aufgeführt. Es lässt sich einzeln definieren, welche Daten gelöscht resp. anonymisiert werden. Ein hinterlegter Personenfilter ermöglicht die Einschränkung der Bearbeitung auf bestimmte Personengruppen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Anonymisierung Profile</code></p>
<h2 id="datenfelder-kopf" tabindex="-1"><a class="header-anchor" href="#datenfelder-kopf"><span>Datenfelder Kopf</span></a></h2>
<dl>
<dt>Profil</dt>
<dd>Frei definierbarer Name für das Profil</dd>
<dt>Filter</dt>
<dd>Der <a class="link" href="ft.refdata.adrfilter.html" title="Personenfilter Kopf">Personenfilter</a> beschränkt die Anonymisierung auf eine definierte Auswahl von Personen.</dd>
<dt>Verwendung</dt>
<dd>Dropdown mit 2 Auswahlmöglichkeiten:<br>&quot;Standard&quot; = Definitionen für Job <a class="link" href="ft.refproc.personanonymisieren.html" title="Anonymisierung (Person)">Anonymisierung (Person)</a><br>&quot;HG-Job&quot; = Definitionen für Job <a class="link" href="ft.refproc.batchanonymisieren.html" title="Anonymisierung (Batch)">Anonymisierung (Batch)</a></dd>
</dl>
<h2 id="datenfelder-positionen" tabindex="-1"><a class="header-anchor" href="#datenfelder-positionen"><span>Datenfelder Positionen</span></a></h2>
<dl>
<dt>PosNr.</dt>
<dd>Positionsnummer (vorgegegeben)</dd>
<dt>Operation</dt>
<dd>
<table>
<thead>
<tr>
<th>Operation</th>
<th>Anonymisierung</th>
<th>Anonymisierung mit Sperre</th>
</tr>
</thead>
<tbody>
<tr>
<td>person</td>
<td>Person-ID bleibt bestehen. Vorname und Nachname werden gelöscht. Beim Nachnamen wird der Text „Anonym [Personen-ID]“ eingetragen. Titel, Sprache, Anrede, Notizen und organisatorische Einheit, Beziehungen, Mutationsschutz-Einträge und Attachements werden gelöscht. Geschlecht und Personentyp bleiben bestehen. Alle anderen Personen- und Adressdaten wedren gelöscht, ausser PLZ/Land der Standardadresse. Geburtsdatum wird zu Geburtsjahr reduziert.</td>
<td>Personen- und Adressdaten werden auf Minimum reduziert: Name, Vorname, aktuelle post. Standardadresse. Notizen und organisatorische Einheit, Beziehungen, Mutationsschutz-Einträge und Attachements werden gelöscht. Die Person wird gesperrt (Ereignis XY &quot;Anonymisierung&quot;).</td>
</tr>
<tr>
<td>auftrag</td>
<td>Auftragsdokumente werden gelöscht.</td>
<td>keine Aktion.</td>
</tr>
<tr>
<td>zusage</td>
<td>Zusagen werden mit der Person-Anonymisierung anonymisiert. Attachments der Zusagen und die Zahlungsverbindungen werden entfernt.</td>
<td>Wenn Zusage ohne Rechnung/Belastung/Zahlung wird sie gelöscht.</td>
</tr>
<tr>
<td>teilnahme</td>
<td>Teilnahmen werden mit der Person-Anonymisierung anonymisiert, Rollen und Teilnehmermerkmale werden gelöscht.</td>
<td>keine Aktion.</td>
</tr>
<tr>
<td>nachlass</td>
<td>Nachlässe werden durch Anonymisierung des Erblassers anonymisiert, Bemerkungen werden gelöscht.</td>
<td>keine Akion.</td>
</tr>
<tr>
<td>ereignis</td>
<td>Ereignisse werden mit der Person-Anonymisierung anonymisiert. Adresseinräge der Ereignisverknüpfngen werden gelöscht.</td>
<td>Ereignisse werden zu &quot;Anonym (Sammeladresse)&quot; verschoben. Adresseinräge der Ereignisverknüpfngen werden gelöscht.</td>
</tr>
<tr>
<td>rest</td>
<td>Merkmalverknüpfungen werden gelöscht. Entfernung aller hinzugefügten und ausgeschlossenen Publikationen, Verteiler aller Publikationen wird auf &quot;nein&quot; gesetzt. Bemerkungstexte werden aus den Aktionen entfernt. Korrespondenzen und zugehörige Dokumente werden gelöscht. Aufgaben werden gelöscht.</td>
<td>Gleich wie bei &quot;Anonymisierung&quot;.</td>
</tr>
<tr>
<td>fremdadr</td>
<td>Ereignisse der zu anonymisierenden Fremdadresse wird zu &quot;Anonym (Sammeladresse)&quot; verschoben und die Fremdadresse danach gelöscht.</td>
<td>nicht relevant.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Aufbewahrung (Jahre)</dt>
<dd>Definiert die Mindest-Aufbewahrungszeit für Daten aus der entsprechenden Operation. Für Buchungen gelten generell 10 Jahre (hardcodiert).</dd>
<dt>Anonymisierung Person</dt>
<dd>Der Eintrag &quot;blockieren&quot; bewirkt, dass während der in &quot;Aufbewahrung (Jahre) definierten Frist, diese Daten resp. die zugehörige Person von einer Anonymisierung ausgeschlossen ist.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/datenschutz/datenschutz.html" title="Kapitel 9. Datenschutz">Datenschutz</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.personanonymisieren.html" title="Anonymisierung (Person)">Anonymisierung (Person)</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.batchanonymisieren.html" title="Anonymisierung (Batch)">Anonymisierung (Batch)</RouteLink></p>
</div></template>


